
define('text!views/pages/cash/methods/wizardMethod.html',[],function () { return '<div data-bind="compose: { model: wizardModel, view: \'views/pages/cash/cashWizard.html\' }, css: wizardModel.methodType"></div>';});

